export const QUICKPAY_PROPS = {
  COLUMNS: {
    PEPSI_PRODUCT_ID: 'Pepsi Product Id',
    PRODUCT_NAME: 'Product Name',
    PRODUCT_IMAGE: 'Product Image',
    ACTIVE: 'Active',
    LAST_CHANGE_DTM: 'Last Change Dtm',
    CREATED_ON: 'Created On',
    UPDATED_ON: 'Updated On',
    ACTION: 'Action',
  },
  FILTERS: {
    SHOW_DELETED: 'Show Deleted',
    BARCODE_PLACEHOLDER: 'Barcode',
    PRODUCT_NAME_PLACEHOLDER: 'Product Name',
    PEPSI_PRODUCT_ID_PLACEHOLDER: 'Pepsi Product Id',
  },
  TABLE: {
    DELETED_ON_PREFIX: 'Deleted On: ',
    HIDE_DETAIL: 'Hide Detail',
    VIEW_DETAIL: 'View Detail',
  },
};
